<template>
    <form
        @submit.prevent="resetPassword"
        :action="url"
        method="post"
        class="card border-2 border-sky-500 space-y-4"
    >
        <div class="py-4 space-y-4">
            <h1 class="text-2xl text-center text-gray-800 uppercase font-semibold">Reset Password</h1>
            <div class="w-12 mx-auto border-b-2 border-gray-300"></div>
        </div>

        <text-input
            label="Email"
            type="email"
            v-model="form.email"
            :error="form.errors.email"
            placeholder="kevin.flynn@encom.com"
        />

        <text-input
            label="Password"
            type="password"
            placeholder="Password"
            v-model="form.password"
            :error="form.errors.password"
        />

        <text-input
            label="Confirm Password"
            type="password"
            placeholder="Password"
            v-model="form.password_confirmation"
            :error="form.errors.password_confirmation"
        />

        <loading-button
            :loading="form.processing"
            class="btn btn-green w-full"
        >
            Reset Password
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'

const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    token: {
        type: String,
        required: true,
    },
    email: {
        type: String,
        required: true,
    }
})

const form = useForm({
    'token': props.token,
    'email': props.email,
    'password': '',
    'password_confirmation': '',
})

const resetPassword = () => {
    form.post(props.url)
}
</script>
